import { getApiActionTypes } from '../../../shared/store/storeHelpers';

export const fetchDefaultBinderItemsTypes = getApiActionTypes(
  'DEVELOPMENT/FETCH_DEFAULT_BINDER_ITEMS',
);
export const fetchBinderItemTypesTypes = getApiActionTypes('DEVELOPMENT/FETCH_BINDER_ITEM_TYPES');
export const fetchFormsTypes = getApiActionTypes('DEVELOPMENT/FETCH_FORMS_FOR_DEFAULT_BINDERS');
export const updateBinderItemsTypes = getApiActionTypes('DEVELOPMENT/UPDATE_BINDER_ITEMS');
